export default __webpack_public_path__ + "static/media/banner.af27f441.jpg";